<template>
  <section class="">
    <section class="q-pa-sm">
      <div class="text-center text-h5"> 
        EXTRATO DE PEDIDO
      </div>
      <div>
        <div>
          DATA: {{now}}
        </div>
      </div>
      <div>
        <div>
          Número Pedido: {{pedido.numPedido}}
        </div>
      </div>
      <div>
        <div>
          CLIENTE: {{pedido.nome}}
        </div>
      </div>
      <div>
        <div>
          USINA: {{pedido.nomeFantasiaInd}}
        </div>
      </div>
      <hr style="border: 1px solid black;" />
    </section>
    <section>
      <table class="table">
        <thead>
          <tr>
            <th class="text-left">Número Nota</th>
            <th class="text-left">Data Emissão</th>
            <th class="text-left">Descrição</th>
            <th class="text-left">Placa Veículo</th>
            <th class="text-right" width="10%">Quantidade Carregada</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(nota, idx) of extrato" :key="idx">
            <td class="text-left">{{nota.numNota}}</td>
            <td class="text-left">{{nota.dataEmissao | date}}</td>
            <td class="text-left">{{nota.descricao}}</td>
            <td class="text-left">{{nota.placaVeiculo}}</td>
            <td class="text-right" width="15%">{{nota.quantProdutosNf | number}}</td>
          </tr>
          <tr>
            <td class="text-right" colspan="4"><strong>Total:</strong></td>
            <td class="text-right" width="15%"><strong>{{total | number}}</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="4"><strong>Total Carregado:</strong></td>
            <td class="text-right" width="10%"><strong>{{totalEntregue | number}}</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="4"><strong>Total Faltante:</strong></td>
            <td class="text-right" width="10%"><strong>{{totalNaoEntregue | number}}</strong></td>
          </tr>
        </tbody>
        <!-- <tfoot class="">
          <tr style="border: 0 padding-top: 0px; width: 100%; height: 60px;  background-color: white;" class="text-center">
            <td colspan="5" style="padding-top: 0px; width: 100%; height: 60px;">
              <div style="position: fixed; left: 0; bottom: 0; width: 100%; text-align: center; background-color: white;">
                <hr style="border: 1px solid black;" /> <br />
                S.R CAL COMÉRCIO E REPRESENTAÇÕES LTDA - CNPJ 12.678.803.0001-89<br>
                Rua 10, N 135, Centro - Água Boa - MT - CEP: 78635-000
              </div>
            </td>
          </tr>
        </tfoot> -->
      </table>
    </section>
    <!-- <section>
      <div class="row">
        <div class="col-6">Calcário SRCAL</div>
      </div>
      <div class="row">
        <div class="col-12">
          <hr style="border: 1px solid black;" />
        </div>
      </div>
      <div class="text-center text-h5">
        EXTRATO DE PEDIDO
      </div>
      <div class="row">
        <div class="float-right">
          DATA: {{now}}
        </div>
      </div>
      <div class="row">
        <div class="float-right">
          Número Pedido: {{pedido.numPedido}}
        </div>
      </div>
      <div class="row">
        <div class="text-left">
          CLIENTE: {{pedido.nome}}
        </div>
      </div>
      <div class="row">
        <div class="text-left">
          USINA: {{pedido.nomeFantasiaInd}}
        </div>
      </div>
      <hr style="border: 1px solid black;" />
    </section>
    <section>
      <table class="table">
        <thead>
          <tr>
            <th class="text-right">Número Nota</th>
            <th>Data Emissão</th>
            <th>Descrição</th>
            <th>Placa Veículo</th>
            <th class="text-right">Quantidade Carregada</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(nota, idx) of extrato" :key="idx">
            <td class="text-right">{{nota.numNota}}</td>
            <td>{{nota.dataEmissao | date}}</td>
            <td>{{nota.descricao}}</td>
            <td>{{nota.placaVeiculo}}</td>
            <td class="text-right">{{nota.quantProdutosNf | number}}</td>
          </tr>
          <tr>
            <td class="text-right" colspan="4"><strong>Total:</strong></td>
            <td class="text-right" width="10%"><strong>{{total | number}}</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="4"><strong>Total Carregado:</strong></td>
            <td class="text-right" width="10%"><strong>{{totalEntregue | number}}</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="4"><strong>Total Faltante:</strong></td>
            <td class="text-right" width="10%"><strong>{{totalNaoEntregue | number}}</strong></td>
          </tr>
        </tbody>
        <tfoot class="">
          <tr style="border: 0 padding-top: 0px; width: 100%; height: 60px;  background-color: white;" class="text-center">
            <td colspan="5" style="padding-top: 0px; width: 100%; height: 60px;">
              <div style="position: fixed; left: 0; bottom: 0; width: 100%; text-align: center; background-color: white;">
                <hr style="border: 1px solid black;" /> <br />
                S.R CAL COMÉRCIO E REPRESENTAÇÕES LTDA - CNPJ 12.678.803.0001-89<br>
                Rua 10, N 135, Centro - Água Boa - MT - CEP: 78635-000
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </section> -->
  </section>
</template>

<script>
import moment from 'moment'
export default {
  name: 'report-extrato',
  props: {
    extrato: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    totalEntregue: {
      type: Number,
      required: true
    },
    totalNaoEntregue: {
      type: Number,
      required: true
    },
    pedido: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    now () {
      return moment().format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>
